export function initSearchOverlay() {
  const overlay = document.querySelector('[data-search-input]')?.closest('.search-overlay');
  const input = document.querySelector('[data-search-input]');
  const openButtons = document.querySelectorAll('[data-search-open]');
  const closeButton = document.querySelector('[data-search-close]');

  if (!overlay || !input || !openButtons.length || !closeButton) {
    return;
  }

  let lastActiveElement = null;

  const open = () => {
    lastActiveElement = document.activeElement;
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('has-overlay');
    window.setTimeout(() => input.focus(), 70);
  };

  const close = () => {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('has-overlay');
    input.value = '';

    if (lastActiveElement && typeof lastActiveElement.focus === 'function') {
      lastActiveElement.focus();
    }
  };

  openButtons.forEach((button) => {
    button.addEventListener('click', open);
  });

  closeButton.addEventListener('click', close);

  overlay.addEventListener('click', (event) => {
    if (event.target === overlay) {
      close();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && overlay.classList.contains('is-open')) {
      close();
    }
  });
}
